import { Link, useLocation } from 'react-router-dom';
import {
  Header as BaseHeader,
  HeaderGlobalBar,
  HeaderMenu,
  HeaderMenuItem,
  HeaderName,
  HeaderNavigation,
  OverflowMenu,
  OverflowMenuItem
} from '@carbon/react';
import { User } from '@carbon/react/icons';

import { routes } from 'core/routing';
import { useAuthController } from 'core/user/auth';
import { useHasAccess } from 'core/user/role';
import { useUser } from 'core/user/user';
import styles from 'theme/features/layout/layout.module.scss';

const ADMIN_LINKS = [
  {
    title: 'Users',
    to: routes.usersAdministration()
  },
  {
    title: 'Groups',
    to: routes.groupsAdministration()
  }
];

const Header = () => {
  const { pathname } = useLocation();

  const { logout } = useAuthController();

  const { user } = useUser();
  const { hasEditAccess, hasAdminAccess } = useHasAccess();
  const hasUser = !!user;

  const LINKS = [
    {
      title: 'Home',
      to: routes.landing()
    },
    {
      title: 'All Projects',
      to: routes.allProjects()
    },
    ...(hasEditAccess()
      ? [
          {
            title: 'Create Project',
            to: routes.createProject()
          }
        ]
      : [])
  ];

  return (
    <BaseHeader aria-label="LCS Web Tool" className={styles.header}>
      <HeaderName element={Link} to={routes.landing()}>
        LCS Planning Calculator
      </HeaderName>
      {hasUser && (
        <>
          <HeaderNavigation aria-label="LCS Web Tool">
            {LINKS.map((link) => (
              <HeaderMenuItem key={link.to} isCurrentPage={link.to === pathname} to={link.to} element={Link}>
                {link.title}
              </HeaderMenuItem>
            ))}
            {hasAdminAccess() && (
              <HeaderMenu aria-label="Administration" menuLinkName="Administration">
                {ADMIN_LINKS.map((link) => (
                  <HeaderMenuItem key={link.to} to={link.to} element={Link}>
                    {link.title}
                  </HeaderMenuItem>
                ))}
              </HeaderMenu>
            )}
          </HeaderNavigation>
          <HeaderGlobalBar>
            <div className={styles['header__actions']}>
              <a
                href="https://www.ibm.com/design/workplace/space-types/welcome/approach/"
                target="_blank"
                rel="noreferrer"
              >
                IBM Guidelines
              </a>
              <OverflowMenu size="lg" ariaLabel="User" renderIcon={(props) => <User size={20} {...props} />} flipped>
                <OverflowMenuItem itemText="Logout" onClick={logout} />
              </OverflowMenu>
            </div>
          </HeaderGlobalBar>
        </>
      )}
    </BaseHeader>
  );
};

export default Header;
